import { useCallback, useRef } from 'react'
import { decodeToken } from '../../helpers/decodeToken'
import { AccessTokenPayload, AuthTokenStorage, Token } from '../../types'
import { useUpdate } from '../utility/useUpdate'

export const useAccessTokenState = (storage: AuthTokenStorage) => {
  const getInitialToken = () => {
    const initialToken = storage.get()
    if (!initialToken) return null
    return decodeToken<AccessTokenPayload>(initialToken)
  }
  const accessTokenRef = useRef<Token<AccessTokenPayload> | null>(getInitialToken())

  const refresh = useUpdate()
  const setAccessToken = useCallback((token: string | null) => {
    const decoded = token ? decodeToken<AccessTokenPayload>(token) : null
    accessTokenRef.current = decoded
    storage.set(decoded?.token || null)
    refresh()
  }, [refresh, storage, accessTokenRef])

  return [accessTokenRef, setAccessToken] as const
}
